import React, { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import { CityContext } from '../../../context/City';

export default function UsersForm({ user, onSubmit }) {
  const { citiesAdmin } = useContext(CityContext);

  const { register, handleSubmit, formState: { errors }, reset } = useForm({
    defaultValues: user || {}
  });

  const [selectedCityId, setSelectedCityId] = useState('');

  const handleCityChange = (event) => {
    setSelectedCityId(event.target.value);
  };

  const submitHandler = async (data) => {
    data.idCity = Number(data.idCity);
    try {
      await onSubmit(data);
      console.log(data);
      reset();
      setSelectedCityId(''); // Сбросить выбранный город после успешной отправки
    } catch (error) {
      console.error("Ошибка при отправке данных:", error);
    }
  };

  return (
    <form onSubmit={handleSubmit(submitHandler)}>
      <div className="form__item">
        <label htmlFor="adminLogin">Имя</label>
        <div>
          <input
            id="adminLogin"
            {...register("adminLogin", { required: "Это поле обязательно" })}
          />
          {errors.adminLogin && <span>{errors.adminLogin.message}</span>}
        </div>
      </div>

      <div className="form__item">
        <label htmlFor="adminPassword">Пароль</label>
        <div>
          <input
            id="adminPassword"
            type="password"
            {...register("adminPassword", {
              required: "Это поле обязательно",
              minLength: {
                value: 6,
                message: "Пароль должен содержать минимум 6 символов"
              },
              validate: {
                hasUpperCase: value => /[A-Z]/.test(value) || "Пароль должен содержать хотя бы одну заглавную букву",
                hasNumber: value => /[0-9]/.test(value) || "Пароль должен содержать хотя бы одну цифру",
                hasSpecialChar: value => /[!@#$%^&*(),.?":{}|<>]/.test(value) || "Пароль должен содержать хотя бы один специальный символ"
              }
            })}
          />
          {errors.adminPassword && <span>{errors.adminPassword.message}</span>}
        </div>
      </div>

      <div className="form__item">
        <label htmlFor="idCity">Город</label>
        <div>
          <select
            id="idCity"
            {...register("idCity", { required: "Выберите город" })}
            onChange={handleCityChange}
            value={selectedCityId}
          >
            {/* Пустая опция по умолчанию */}
            <option value="">Выберите город</option>
            {citiesAdmin.map(city => (
              <option key={city.id} value={city.id}>{city.name}</option>
            ))}
          </select>
          {errors.idCity && <span>{errors.idCity.message}</span>}
        </div>
      </div>

      <button type="submit">Сохранить</button>
    </form>
  );
}